/**
 * TabBar Icons — AETERNA VI 设计系统自然意象图标
 *
 * 来源: docs-hc/01-Product-Design/长寿市场研究/02-Design-System/vi/tabbar-icons.html
 * 照见 = 日出/微光 | 践行 = 涟漪/水波 | 真知 = 矿石/晶体 | 同行 = 双叶/共生 | 解惑 = 水滴/清泉
 */
import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

const shared = (size: number, color: string, strokeWidth: number): React.SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: color,
  strokeWidth,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
});

/** 照见 — 日出/微光 · 觉察与洞察 */
export function IlluminateIcon({ size = 24, color = 'currentColor', strokeWidth = 1.5 }: IconProps) {
  return (
    <svg {...shared(size, color, strokeWidth)}>
      <line x1="12" y1="3" x2="12" y2="1" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      <path d="M6 12a6 6 0 0 1 6-6" />
      <path d="M18 12a6 6 0 0 1-6 6" />
    </svg>
  );
}

/** 践行 — 涟漪/水波 · 行动的扩散 */
export function ExecuteIcon({ size = 24, color = 'currentColor', strokeWidth = 1.5 }: IconProps) {
  return (
    <svg {...shared(size, color, strokeWidth)}>
      <circle cx="12" cy="12" r="2" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="8" />
      <path d="M18 8c1.5 1.5 2 3 2 4s-.5 2.5-2 4" opacity={0.4} />
    </svg>
  );
}

/** 真知 — 矿石/晶体 · 知识的维度 */
export function KnowledgeIcon({ size = 24, color = 'currentColor', strokeWidth = 1.5 }: IconProps) {
  return (
    <svg {...shared(size, color, strokeWidth)}>
      <path d="M12 3l7.5 4.5v9L12 21l-7.5-4.5v-9L12 3z" />
      <path d="M12 12l7.5-4.5" />
      <path d="M12 12v9" />
      <path d="M12 12L4.5 7.5" />
    </svg>
  );
}

/** 同行 — 双叶/共生 · 陪伴与成长 */
export function GenerosityIcon({ size = 24, color = 'currentColor', strokeWidth = 1.5 }: IconProps) {
  return (
    <svg {...shared(size, color, strokeWidth)}>
      <path d="M12 20c0-4-3-7-7-7s-3 7 3 7c2 0 4-1 4-3" />
      <path d="M12 20c0-4 3-7 7-7s3 7-3 7c-2 0-4-1-4-3" />
      <path d="M12 20V10" />
      <path d="M12 10c-2-2-2-5-2-8" />
      <path d="M12 10c2-2 2-5 2-8" />
    </svg>
  );
}

/** 解惑 — 水滴/清泉 · 疑惑的澄清 */
export function AskIcon({ size = 24, color = 'currentColor', strokeWidth = 1.5 }: IconProps) {
  return (
    <svg {...shared(size, color, strokeWidth)}>
      <path d="M12 3c-4 6-7 9-7 12a7 7 0 0 0 14 0c0-3-3-6-7-12z" />
      <path d="M12 18a2 2 0 0 0 2-2" opacity={0.4} />
    </svg>
  );
}
